import { Component, inject, OnInit, OnDestroy } from '@angular/core'
import { CommonModule } from '@angular/common'
import { combineLatest } from 'rxjs'
import { map } from 'rxjs/operators'
import { FreezeService } from '@educational-initiatives/angular-web-utilities'

@Component({
    selector: 'app-freeze',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './freeze.component.html',
    styleUrls: ['./freeze.component.scss'],
})
export class FreezeComponent implements OnInit, OnDestroy {
    private freezeService = inject(FreezeService)
    private subscription: { unsubscribe: () => void } | null = null

    freezeState: { isFrozen: boolean; message: string } = { isFrozen: false, message: '' }

    ngOnInit(): void {
        this.subscription = combineLatest([
            this.freezeService.isFrozen,
            this.freezeService.freezeMessage,
        ])
            .pipe(map(([isFrozen, message]) => ({ isFrozen, message })))
            .subscribe((state) => {
                this.freezeState = state

                // Manage body scroll
                if (state.isFrozen) {
                    document.body.style.overflow = 'hidden'
                } else {
                    document.body.style.overflow = ''
                }
            })
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe()
        // Restore scrolling on component destroy
        document.body.style.overflow = ''
    }
}
